import user from '@/components/common/user'
import * as types from '@/store/mutation-types'

// 获得登录用户信息
export const getLoginMemberInfo = ({
  commit
}, hasLoading = false) => {
  return user.getLoginMemberModel(hasLoading).then(res => {
    commit(types.UPDATE_MEMBERINFO, res.data.AdminUser)
    commit(types.UPDATE_MEMBERPOWER, res.data.ModuleList)
  })
}



// WEBPACK FOOTER //
// ./src/store/common/actions.js